// Utils
import {hasChecksheetFilter} from "./notificationPreviewUtils.js";
import formatTime from "./notificationTimeUtils.js";

const FILTER_LABELS = {Remind: "Outstanding"};

const formatRecipients = (recipients = {}) => {
  const list = Object.values(recipients);
  if (list[0]?.isRole) return list.map(({label}) => label).join(", ");
  return list.flatMap(({users}) => users || []).join(", ");
};

const formatSchedule = (frequency, times) => {
  if (!times?.length) return frequency;
  const prefix = frequency === "Daily" ? "at" : "on";
  return `${frequency} ${prefix} ${formatTime(times, frequency)}`;
};

/**
 * Flattens the save response's filteredNotifications (type → frequency → group) into modal rows.
 * Groups with a checksheet include-list skip any sheet not on it, so a newly live sheet never
 * reaches them until someone adds it.
 * @param {object} notifications
 * @returns {Array<object>}
 */
const getFilteredNotificationGroups = notifications =>
  Object.entries(notifications || {})
    .filter(([type]) => hasChecksheetFilter(type))
    .flatMap(([type, byFrequency]) =>
      Object.entries(byFrequency || {}).flatMap(([frequency, groups]) =>
        Object.entries(groups || {})
          .filter(([, {checksheetIds}]) => checksheetIds?.length > 0)
          .map(([ids, {recipients, times, checksheetIds}]) => ({
            key: `${type}-${frequency}-${ids}`,
            type,
            label: FILTER_LABELS[type] || type,
            schedule: formatSchedule(frequency, times),
            recipients: formatRecipients(recipients),
            checksheetCount: checksheetIds.length
          }))
      )
    );

export default getFilteredNotificationGroups;
